import React from 'react';
import { useTenant } from '../TenantProvider';
import { Building2 } from 'lucide-react';

export default function CompanyDebugBar({ onChoose }) {
  const { activeCompany } = useTenant();

  if (!activeCompany) return null;

  return (
    <div className="w-full bg-slate-900/70 border-b border-slate-800/70">
      <div className="max-w-full px-6 py-2 flex items-center gap-3 text-xs text-slate-300">
        <Building2 className="w-4 h-4 text-cyan-400" />
        <span className="font-medium text-slate-100">{activeCompany.name}</span>
        <span className="text-slate-500">•</span>
        <span className="font-mono">slug: <span className="text-slate-200">{activeCompany.id}</span></span>
        <span className="text-slate-500">•</span>
        <span className="font-mono">numeric_id: <span className="text-slate-200">{activeCompany.numeric_id}</span></span>

        <button
          className="ml-auto px-2 py-1 bg-slate-800/60 hover:bg-slate-800 border border-slate-700/50 rounded-md text-slate-200"
          onClick={onChoose}
          title="Choose another company"
        >
          Choose…
        </button>
      </div>
    </div>
  );
}